export default "__VITE_ASSET__D72W5rWd__"